import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import NavBar from '../../components/navBar';

const DesacSports = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900">
      <NavBar />
      
      {/* Hero Section */}
      <div className="relative flex items-center justify-center" style={{ height: 'calc(100vh - 4rem)' }}>
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 container mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              DESAC Sports
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              The premier platform for sports management, competition, and talent development in Zambia
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/desac-sports/rising-stars-registration')}
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold text-lg transition-colors flex items-center justify-center"
              >
                Register for Rising Stars
                <ArrowRightIcon className="h-5 w-5 ml-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesacSports; 